// extracted by mini-css-extract-plugin
module.exports = {"btnaddfocus":"index_btnaddfocus_1Ndj5","header":"index_header_3KHjg"};